"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var authentication_1 = require("./authentication");
var defaultRequestOptions = {
    json: true,
    tryAuth: true,
    headers: {
        'Content-Type': 'application/json'
    }
};
var ApiProvider = /** @class */ (function () {
    function ApiProvider() {
        this.authProvider = authentication_1.defaultAuthProvider;
        this.commonHeaders = {
            'Content-Type': 'application/json',
        };
    }
    ApiProvider.prototype.request = function (method, resourceUrl, options) {
        return __awaiter(this, void 0, void 0, function () {
            var mOptions, response, session;
            var _this = this;
            return __generator(this, function (_a) {
                mOptions = __assign({}, defaultRequestOptions, (options || {}));
                if (this.authProvider) {
                    session = this.authProvider.getSession();
                    if (session && session.accessToken) {
                        this.commonHeaders['Authorization'] = "Bearer " + session.accessToken;
                    }
                }
                return [2 /*return*/, fetch(resourceUrl, __assign({}, (mOptions ? mOptions : {}), { method: method, headers: __assign({}, this.commonHeaders, (mOptions ? (mOptions.headers || {}) : {})), body: mOptions.json ? JSON.stringify(mOptions.body) : mOptions.body }))
                        .then(function (r) {
                        response = r;
                        return (function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                if (mOptions.json) {
                                    return [2 /*return*/, response.json()];
                                }
                                return [2 /*return*/, response.body];
                            });
                        }); })();
                    })
                        .then(function (data) {
                        return (function () { return __awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            return __generator(this, function (_a) {
                                if (response.status >= 400) {
                                    if (response.status === 401 &&
                                        this.authProvider && mOptions.tryAuth &&
                                        (this.authProvider.getSession() || {}).refreshToken) {
                                        return [2 /*return*/, this.authProvider.refreshToken()
                                                .then(function (session) {
                                                if (!session) {
                                                    _this.authProvider.doLogout();
                                                    return Promise.reject({ data: data, response: response });
                                                }
                                                _this.authProvider.setSession(session);
                                                mOptions.tryAuth = false;
                                                return _this.request(method, resourceUrl, mOptions);
                                            })
                                                .catch(function (errResponse) {
                                                return Promise.reject({ data: errResponse.data, response: errResponse.response });
                                            })];
                                    }
                                    return [2 /*return*/, Promise.reject({ data: data, response: response })];
                                }
                                return [2 /*return*/, Promise.resolve({ data: data, response: response })];
                            });
                        }); })();
                    })
                        .catch(function (response) {
                        return Promise.reject(response);
                    })];
            });
        });
    };
    ApiProvider.prototype.get = function (resource, options) {
        return this.request('GET', resource, options);
    };
    ApiProvider.prototype.post = function (resource, options) {
        return this.request('POST', resource, options);
    };
    ApiProvider.prototype.put = function (resource, options) {
        return this.request('PUT', resource, options);
    };
    ApiProvider.prototype.patch = function (resource, options) {
        return this.request('PATCH', resource, options);
    };
    ApiProvider.prototype.delete = function (resource, options) {
        return this.request('DELETE', resource, options);
    };
    return ApiProvider;
}());
exports.default = ApiProvider;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../@core/dist/providers/api.js
// module id = 168
// module chunks = 0